export default "__VITE_ASSET__Bp7kx1D5__"